import Alpine from "../alpine.js"

Alpine.data("combobox", (items, selectedValue = null) => ({
  items,
  selectedValue,
  search: "",
  open: false,
  activeIndex: null,
  filteredItems: items,
  init () {
    this.setDisplayValue()
  },
  selectItem (item) {
    this.filteredItems = this.items
    this.activeIndex = null
    this.search = item[0]
    this.selectedValue = item[1]
    this.$dispatch('combobox-select', { value: this.selectedValue })
    this.close()
  },
  isDisabledItem () {
    return false
  },
  isSelectedItem (item) {
    return this.selectedValue === item[1]
  },
  isActiveItem (item) {
    return item === this.filteredItems[this.activeIndex]
  },
  filterOptions (event) {
    this.search = event.target.value
    if (!this.open) { this.open = true }

    this.filteredItems = this.search === ''
      ? this.items
      : this.items.filter((item) => {
        return item[0].toLowerCase().includes(this.search.toLowerCase())
      })

    if (this.filteredItems.length > 0) {
      this.activeIndex = 0
    }
  },
  setDisplayValue () {
    if (this.selectedValue) {
      let item = this.items.find((item) => { return this.selectedValue === item[1] })

      if (item) {
        this.search = item[0]
      } else {
        option = this.secondaryOptions?.find((option) => {
          return this.value === option[1]
        })
        if (option) { this.search = option[0] }
      }
    } else {
      this.search = ""
    }
  },
  up () {
    if (this.activeIndex === null) { this.activeIndex = 1 }

    if (this.activeIndex > 0) {
      this.activeIndex--
    }
  },
  down () {
    if (this.activeIndex === null) { this.activeIndex = -1 }

    if (this.activeIndex < this.filteredItems.length - 1) {
      this.activeIndex++
    }
  },
  enter () {
    if (this.activeIndex !== null) {
      let item = this.filteredItems[this.activeIndex]
      if (item) {
        this.selectItem(item)
      }
    }
  },
  close () {
    this.open = false
    if (this.selectedValue) {
      let item = this.items.find((item) => { return this.selectedValue === item[1] })
      if (item) {
        this.search = item[0]
        this.$refs.inputField.value = item[0]
      }
    } else {
      this.search = ""
      this.$refs.inputField.value = ""
    }
    this.filteredItems = this.items
  }
}))
